import { Fragment } from 'react';

import { Card } from 'src/components/ui/card';
import { Skeleton } from 'src/components/ui/skeleton';

type Props = {
  count?: number;
};

const SoftwareDashboardSkeletonItem = () => (
  <Card>
    <div className="p-4 sm:p-6">
      <div className="flex items-start justify-between gap-2 mb-2">
        <Skeleton className="h-6 w-24 rounded" />
        <Skeleton className="size-6 rounded-full" />
      </div>
      <Skeleton className="h-4 w-32 mb-5" />

      <div className="flex flex-wrap items-center gap-2 mb-6">
        <div className="flex items-center gap-2">
          <Skeleton className="size-6 rounded-sm" />
          <Skeleton className="h-5 w-24" />
        </div>
        <Skeleton className="size-5" />
        <div className="flex items-center gap-2">
          <Skeleton className="size-6 rounded-sm" />
          <Skeleton className="h-5 w-24" />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {Array.from({ length: 3 }).map((_, itemIndex) => (
          <div key={itemIndex} className="text-xs pr-2">
            <div className="flex items-center gap-1 mb-1">
              <Skeleton className="size-4 rounded-sm" />
              <Skeleton className="h-3 w-20" />
            </div>
            <Skeleton className="h-4 w-24" />
          </div>
        ))}
      </div>
    </div>
  </Card>
);

const SoftwareDashboardSkeleton = ({ count = 4 }: Props) => (
  <Fragment>
    <div className="border-b border-border">
      <div className="container mx-auto">
        <div className="flex items-center justify-between gap-2 bg-white p-4 sm:p-6">
          <div className="flex items-center gap-2 sm:gap-4 grow">
            <Skeleton className="h-10 w-full md:max-w-[320px]" />
            <Skeleton className="h-10 w-5 sm:w-30" />
          </div>
          <Skeleton className="h-10 w-5 sm:w-30" />
        </div>
      </div>
    </div>
    <div className="container mx-auto">
      <div className="@container p-4 sm:p-6">
        <div className="grid grid-cols-1 @max-3xl:grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-6">
          {Array.from({ length: count }).map((_, index) => (
            <SoftwareDashboardSkeletonItem key={index} />
          ))}
        </div>
      </div>
    </div>
  </Fragment>
);

export default SoftwareDashboardSkeleton;
